import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  isLoading: boolean;
}

const initialState: AppState = {
  isLoading: false
};

export const fetchDashboardData = createAsyncThunk('app/fetchDashboardData', async () => {
  await new Promise<void>(resolve => {
    setTimeout(resolve, 1500);
  });
  return { students: 46, avgHesi: 805, atRisk: 18, noLogins: 7 };
});

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDashboardData.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchDashboardData.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(fetchDashboardData.rejected, state => {
        state.isLoading = false;
      });
  }
});

export const { setLoading } = appSlice.actions;
export const appReducer = appSlice.reducer;
